import { get } from 'lodash'
import { createSelector } from 'reselect'
import { DateTime } from 'luxon'

export const getTournamentId = (state: StoreState) => state.tournamentReducer.tournamentSite.tournament.id

const isCurrentDateBetweenSelections = (
  registerAndCancelTimeFramesEnabled: boolean,
  startsStr?: string,
  endsStr?: string,
) => {
  if (!registerAndCancelTimeFramesEnabled) {
    return true
  }

  if (startsStr && endsStr) {
    const starts = DateTime.fromISO(startsStr)
    const ends = DateTime.fromISO(endsStr)
    return DateTime.local() >= starts && DateTime.local() <= ends
  } else {
    return true
  }
}

export const areRegisterAndCancelTimeFramesEnabled = (state: StoreState) =>
  get(state, 'tournamentReducer.tournamentSite.registerAndCancelTimeFramesEnabled')

export const getRegistrationCancellingStartsTime = (state: StoreState) =>
  get(state, 'tournamentReducer.tournamentSite.registrationCancellingStartsTime')
export const getRegistrationCancellingEndsTime = (state: StoreState) =>
  get(state, 'tournamentReducer.tournamentSite.registrationCancellingEndsTime')

export const getRegistrationStartsTime = (state: StoreState) =>
  get(state, 'tournamentReducer.tournamentSite.registrationStartsTime')
export const getRegistrationEndsTime = (state: StoreState) =>
  get(state, 'tournamentReducer.tournamentSite.registrationEndsTime')

export const isRegistrationOpen = createSelector(
  areRegisterAndCancelTimeFramesEnabled,
  getRegistrationStartsTime,
  getRegistrationEndsTime,
  isCurrentDateBetweenSelections,
)

export const isCancelRegistrationOpen = createSelector(
  areRegisterAndCancelTimeFramesEnabled,
  getRegistrationCancellingStartsTime,
  getRegistrationCancellingEndsTime,
  isCurrentDateBetweenSelections,
)
